import * as React from "react";

function SearchIcon(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke={props.fill}
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
      />
      <path
        fill="none"
        stroke={props.fill}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M338.29 338.29L448 448"
      />
    </svg>
  );
}

export default SearchIcon;
